module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeslot"
  }, [_c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('h6', [_vm._v(_vm._s(_vm.formattedDateRange))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.id ? (_vm.form.title ? _vm.form.title : 'Bestaand tijdblok') : 'Nieuw tijdblok'))])]), _vm._v(" "), (_vm.selectedSchedule) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "danger",
      "title": "Tijdblok verwijderen"
    },
    on: {
      "click": _vm.deleteOne
    }
  }, [(!_vm.isDeletingTimeSlot) ? _c('fa-icon', {
    attrs: {
      "icon": "trash"
    }
  }) : _c('loader-spinner', {
    attrs: {
      "iscolor": "#F0F0F0",
      "show-spinner": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "title": "Opslaan"
    },
    on: {
      "click": function($event) {
        _vm.selectedTime ? _vm.create() : _vm.update()
      }
    }
  }, [(!_vm.isUpdatingTimeSlot && !_vm.isCreatingTimeSlot) ? _c('fa-icon', {
    attrs: {
      "icon": "save"
    }
  }) : _c('loader-spinner', {
    attrs: {
      "iscolor": "#F0F0F0",
      "show-spinner": true
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Sluit"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1)], 1), _vm._v(" "), _c('general-input', {
    staticClass: "mb-2",
    attrs: {
      "label": "Titel",
      "placeholder": "Vul een titel in"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('general-select', {
    staticClass: "mb-2",
    attrs: {
      "label": "Type",
      "placeholder": "Selecteer een type afspraak",
      "options": _vm.typeOptions
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }), _vm._v(" "), _c('general-input', {
    attrs: {
      "inputType": "number",
      "label": "Max. aantal afspraken",
      "placeholder": "10"
    },
    model: {
      value: (_vm.form.max_appointments),
      callback: function($$v) {
        _vm.$set(_vm.form, "max_appointments", $$v)
      },
      expression: "form.max_appointments"
    }
  }), _vm._v(" "), (_vm.selectedSchedule && _vm.selectedSchedule.raw.max_appointments) ? _c('div', {
    staticClass: "appointments"
  }, [(!_vm.appointmentWindow) ? [_c('div', {
    staticClass: "d-flex mb-3 mt-4"
  }, [_c('h4', {
    staticClass: "flex-grow-1 mb-0 align-self-end"
  }, [_vm._v("Afspraken")]), _vm._v(" "), (!_vm.appointmentWindow) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "outline-primary",
      "title": "Afspraak maken"
    },
    on: {
      "click": function($event) {
        _vm.appointmentWindow = true
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "plus"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.appointments), function(appointment) {
    return _c('appointment', {
      key: appointment.id,
      staticClass: "mb-3",
      attrs: {
        "appointment": appointment
      },
      on: {
        "deleted": function($event) {
          return _vm.$emit('update', _vm.id)
        }
      }
    })
  }), _vm._v(" "), (!_vm.appointments.length) ? _c('div', {
    staticClass: "timeslot-appointments"
  }, [_vm._v("\n                    Er zijn nog geen afspraken gemaakt.\n                ")]) : _vm._e()] : _c('appointment-form', {
    attrs: {
      "timeSlotId": _vm.id
    },
    on: {
      "close": function($event) {
        _vm.appointmentWindow = false
      },
      "created": function($event) {
        return _vm.$emit('update', _vm.id)
      }
    }
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3eaab52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Planning/Timeslot.vue
// module id = 1339
// module chunks = 1